/**
 * 一手app路由跳转等公用方法
 */

import { sendMiniClick } from "@/util/data-report.js";

export const GetQueryString = (name) => {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(
    location.href.indexOf("#/?") !== -1 ? location.hash : location.search
  );
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

let isAndroid,
  isiOS,
  uid = "",
  token = "",
  version = "",
  isweb = false;

// 判断客户端系统
function androidOrIos() {
  const u = navigator.userAgent;
  isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
  isiOS =
    !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || u.indexOf("Mac OS X") !== -1;
}

// 获取url上的参数
function getInfoFromUrl() {
  uid = GetQueryString("uid") || "";
  token = GetQueryString("token") || "";
  version = GetQueryString("app_version") || "";
  isweb = (GetQueryString("isweb") || "") === "1"; // 参数为1时，表示运营用于发短信用，在手机浏览器直接拉起app相应原生页面
}

androidOrIos();
getInfoFromUrl();
/**
 * 跳转原生公用方法
 * @param type 0-商详 1-专场详情 2-档口详情 3-搜索结果 4-分类页 5-直播页 6-直播回放页 7-直播列表 8-一手币商详（小程序暂缺）
 * 9-邀请好友返现金（小程序暂缺）10-问答详情(小程序暂缺) 11-联系客服 12-服务支付页 13-营业执照页 14-一手币商城 15-我的卡券
 * 16-人工认证页 17-直播简介 18-app webview 19-进货车 20-分类页-风格 21-一手大学 22-今日特卖 23-今日特卖限时秒杀 63-达人列表
 * @param id-本身id
 * @param fromId 数据组的来源id
 * @param keyword 需要的字符串(如搜索关键词)
 * @param obj 额外参数
 */
export const goToApp = ({
  type = 0,
  id = "",
  fromId = 0,
  keyword = "",
  goods_no = "",
  obj = {},
}) => {
  // 小程序流程
  if (window.__wxjs_environment === "miniprogram") {
    if (type === 0) {
      // 上报点击事件
      sendMiniClick({
        opt: {
          goodsId: id,
          h5Url: location.href,
          modelSource: "H5固化模板",
          source: fromId,
          goodsNo: goods_no,
        },
      });
      // 商详
      wx.miniProgram.navigateTo({
        url: `/pages/product-detail/product-detail?id=${id}&fromid=${fromId}&source=products`,
      });
    }
    // 专场
    if (type === 1) {
      wx.miniProgram.navigateTo({
        url: `/pages/products/products?id=${id}`,
      });
    }
    // 档口
    if (type === 2) {
      wx.miniProgram.navigateTo({
        url: `/pages/supplier-detail/supplier-detail?id=${id}`,
      });
    }
    // 搜索结果页
    if (type === 3) {
      wx.miniProgram.navigateTo({
        url: `/pages/search-result/search-result?keyword=${keyword}`,
      });
    }
    // 跳转 webview
    if (type === 18) {
      console.log(obj.url);
      const url = encodeURIComponent(obj.url);
      wx.miniProgram.navigateTo({
        url: "/pages/webview/webview?url=" + url,
      });
    }
    // 分类页
    // if (type === 4) {
    //   wx.miniProgram.navigateTo({
    //     url: `pages/search-result/search-result?keyword=${keyword}`
    //   });
    // }
    return;
  }
  // app流程
  let params = {};
  if (type === 0) {
    // 商详
    console.log(`跳转app商详 id:${id} - no:${goods_no} 来源${fromId}`);
    params = {
      check_login: 0,
      android_class_name: "GoodsDetailActivity",
      ios_class_name: "FMDetailViewController",
      goods_id: id,
      goods_no,
      replenishmentSource: fromId,
    };
  }
  if (type === 1) {
    // 专场
    console.log(`app 专场 id${id} 来源${fromId}`);
    params = {
      check_login: 0,
      android_class_name: "SessionActivity",
      ios_class_name: "FMSpecialDetailController",
      special_id: id,
      specialSource: fromId,
    };
  }
  if (type === 2) {
    // 档口
    console.log(`app 档口 id${id} 来源${fromId}`);
    params = {
      check_login: 0,
      android_class_name: "StallActivity",
      ios_class_name: "FMStallDetailController",
      supplier_id: id,
      source: fromId,
    };
  }
  if (type === 3) {
    // 搜索结果
    params = {
      check_login: 0,
      android_class_name: "SearchResultActivity",
      ios_class_name: "FMSearchListController",
      supplier_id: id,
      keyword,
      source: fromId,
    };
  }
  if (type === 4) {
    // 分类页
    console.log(`app 分类页 id${id} 来源${fromId}`);
    params = {
      check_login: 0,
      android_class_name: "CategoryActivity",
      ios_class_name: "FMClassifyDetailController",
      cate_name: keyword,
      cate_p_id: id,
      cate_menu_ident: "cat_id",
      source: fromId,
    };
  }
  if (type === 5) {
    // 直播间
    console.log("type5", obj);
    params = {
      check_login: 0,
      android_class_name: "VideoActivity",
      ios_class_name: "FMTencentLiveController",
      room_data: {
        room_id: obj.room_id,
        im_group_id: obj.im_group_id,
        pull_url: obj.pull_url,
        record_url: obj.record_url,
        status: obj.status,
      },
      link_type: "26",
      room_id: obj.room_id,
    };
  }

  if (type === 6) {
    // 点播
    params = {
      check_login: 0,
      android_class_name: "VideoActivity",
      ios_class_name: "FMTencentVodController",
      room_data: {
        room_id: obj.room_id,
        im_group_id: obj.im_group_id,
        pull_url: obj.pull_url,
        record_url: obj.record_url,
        status: obj.status,
        end_time: obj.end_time,
        start_time: obj.start_time,
        title: obj.title,
      },
      link_type: "26",
      room_id: obj.room_id,
    };
  }

  if (type === 7) {
    // 直播列表
    params = {
      check_login: 0,
      android_class_name: "VideoListActivity",
      ios_class_name: "FMLiveRoomController",
    };
  }

  if (type === 8) {
    // 一手币商详
    console.log(`app 一手币商详 id${id} 来源${fromId}`);
    params = {
      check_login: 0,
      android_class_name: "GoodsDetailChangeActivity",
      ios_class_name: "FMQADetailViewController",
      goods_id: id,
      replenishmentSource: fromId, // todo 暂缺
    };
  }

  if (type === 9) {
    // 跳转分享
    // if (isiOS) {
    //   invitation();
    // } else if (isAndroid) {
    //   NativeInvitation.invitation();
    // }
  }
  if (type === 10) {
    // 问答详情
    console.log("obj", obj);
    params = {
      check_login: 0,
      android_class_name: "ShopKeeperAnswerActivity",
      ios_class_name: "FMQADetailViewController",
      supply_id: obj.supply_id, // 档口id
      question_id: obj.question_id, // 问题id
    };
  }

  if (type === 11) {
    // 联系客服
    params = {
      check_login: "0",
      android_class_name: "OpenQiyuChatActivity",
      ios_class_name: "FMQYIMManager",
    };
  }
  if (type === 12) {
    // 服务支付页
    params = {
      check_login: 1,
      android_class_name: "VipOrderSettlementActivity",
      ios_class_name: "FMAuthPayController",
      service_id: obj.serviceId,
      alertImg: obj.alertImg,
      vipSource: obj.vipSource || "0",
    };
  }
  if (type === 13) {
    // 营业执照页
    params = {
      check_login: 1,
      android_class_name: "AuthActivity",
      ios_class_name: "FMBusinessLicenseController",
    };
  }
  if (type === 14) {
    // 一手币商城
    params = {
      check_login: 0,
      android_class_name: "ChangeGoodsActivity",
      ios_class_name: "FMTransferMarketController",
    };
  }
  if (type === 15) {
    // 我的卡券
    params = {
      check_login: 1,
      android_class_name: "CouponListActivity",
      ios_class_name: "FMTicketViewController",
    };
  }
  if (type === 16) {
    // 人工认证页
    params = {
      check_login: 1,
      android_class_name: "ArtificailAuthenticationActivity",
      ios_class_name: "FMArtificialAuthenticationViewController",
    };
  }
  if (type === 17) {
    // 直播简介
    params = {
      check_login: 0,
      android_class_name: "VideoPreViewActivity",
      ios_class_name: "FMTencentPreviewController",
      room_data: {
        room_id: obj.room_id,
        im_group_id: obj.im_group_id,
        record_url: obj.record_url,
        status: obj.status,
      },
      room_id: obj.room_id,
    };
  }
  if (type === 18) {
    // app webview
    console.log("obj.url", obj.url);
    params = {
      check_login: 0,
      android_class_name: "WebViewActivity",
      ios_class_name: "FMCommonWebViewController",
      url: obj.url,
    };
  }
  if (type === 19) {
    // 进货车
    params = {
      check_login: 1,
      android_class_name: "ShoppingMainFragment",
      ios_class_name: "FMCarViewController",
    };
  }
  if (type === 20) {
    // 分类页-风格
    console.log(`app 分类页-风格${id} 来源${fromId} 风格${keyword}`);
    params = {
      check_login: 0,
      android_class_name: "CategoryActivity",
      ios_class_name: "FMClassifyDetailController",
      cate_name: keyword, // 原生分格标题
      cate_p_id: id, // 这里的id实际是中文风格名
      cate_menu_ident: "goods_style",
      source: fromId,
    };
  }
  if (type === 21) {
    // 一手大学
    console.log(`app 一手大学`);
    params = {
      check_login: 0,
      android_class_name: "XiaoeTongWebViewActivity",
      ios_class_name: "FMCollegeController",
    };
  }
  if (type === 22) {
    // 今日特卖
    console.log(`app 今日特卖`);
    params = {
      check_login: 0,
      android_class_name: "DiscountGoodActivity",
      ios_class_name: "FMTodaySpecialOfferController",
    };
  }
  if (type === 23) {
    // 今日特卖限时秒杀
    console.log(`app 今日特卖限时秒杀`);
    params = {
      check_login: 0,
      android_class_name: "SecKillActivity",
      ios_class_name: "FMSaleTimeLimitedController",
    };
  }
  if (type === 63) {
    // 今日特卖限时秒杀
    console.log(`app 达人列表`);
    params = {
      check_login: 0,
      android_class_name: "ExpertTabActivity",
      ios_class_name: "FMTalentFeedsViewController",
    };
  }
  params = JSON.stringify(params);
  if (isweb) {
    openAppInNavi(params);
  } else {
    androidOrIos();
    if (isiOS) window.webkit.messageHandlers.callNativePage.postMessage(params);
    if (isAndroid) NativeInvitation.callNativePage(params);
  }
};
// 跳转原生登录页
export const goToLogin = () => {
  // 小程序流程
  if (window.__wxjs_environment === "miniprogram") {
    // 搜索结果页
    wx.miniProgram.navigateTo({
      url: `/pages/bind-phone/bind-phone`, // todo:小程序不走原来密码登录逻辑
    });
    return;
  }
  let params = {
    check_login: 1,
    android_class_name: "LoginActivity",
    ios_class_name: "FMPhoneLoginController",
  };
  params = JSON.stringify(params);
  // isweb 为1时，表示运营用于发短信用，在手机浏览器直接拉起app相应原生页面
  if (isweb) {
    // 跳转登录时不需要
    let goToWebView = {
      check_login: 0,
      android_class_name: "WebViewActivity",
      ios_class_name: "FMCommonWebViewController",
      url: location.href.split("isweb=1")[0],
    };
    goToWebView = JSON.stringify(goToWebView);
    openAppInNavi(goToWebView);
    // 原来
    // openAppInNavi(params)
  } else {
    androidOrIos();
    if (isiOS) {
      // try里是旧ios方法 找不到旧方法调catch里的新方法
      try {
        callNativePage(params);
      } catch (e) {
        window.webkit.messageHandlers.callNativePage.postMessage(params);
      }
    }
    if (isAndroid) {
      NativeInvitation.callNativePage(params);
    }
  }
};
// 所有图片加载完成后回调
export const imgLoaded = () => {
  const temp = document.querySelectorAll("img");
  let srcList = Array.prototype.map.call(temp, function (item) {
    return item.src;
  });
  let promiseAll = [],
    img = [],
    imgTotal = srcList.length;
  let tempcount = 0;
  for (let i = 0; i < imgTotal; i++) {
    promiseAll[i] = new Promise((resolve, reject) => {
      img[i] = new Image();
      img[i].src = srcList[i];
      img[i].onload = function () {
        // 第i张加载完成
        tempcount += 1;
        resolve(img[i].src);
      };
      img[i].onError = function () {
        // 第i张加载完成
        console.error(`第${i + 1}张加载失败`, img[i].src);
        reject(img[i].src);
      };
    });
  }
  return Promise.all(promiseAll);
};

function changeTitle(title) {
  document.title = title || "一手女装批发";
  let i = document.createElement("iframe");
  i.style.display = "none";
  i.src = "https://static.yishouapp.com/V7OLQdXZHA.txt"; // 加载当前页面下一个体积小的资源，比如favicon.ico
  i.onload = () => {
    setTimeout(() => {
      i.remove();
    }, 0);
  };
  document.body.appendChild(i);
}

// 设置网页标题
export const setTitle = (title = "") => {
  if (isAndroid) {
    document.getElementsByTagName("title")[0].innerText =
      title || "一手女装批发网";
  }
  if (isiOS) {
    changeTitle(title);
  }
};

// 跳转原生搜索
export const goToSearch = () => {
  let params = {
    check_login: 0,
    android_class_name: "SearchActivity",
    ios_class_name: "FMSearchController",
  };
  // params = JSON.stringify(params);
  if (isiOS) {
    // try里是旧ios方法 找不到旧方法调catch里的新方法
    try {
      callNativePage(params);
    } catch (e) {
      window.webkit.messageHandlers.callNativePage.postMessage(params);
    }
  } else if (isAndroid) {
    NativeInvitation.callNativePage(params);
  }
};

export const goToAnother = (params) => {
  const hadParams = params.url.indexOf("?") !== -1;
  const newUrl = `${params.url}${
    hadParams ? "&" : "?"
  }uid=${uid}&token=${token}`;
  NativeInvitation.loadWebViewUrl(newUrl);
  // window.location.replace(newUrl)
  // location.reload()
};
// 运营位，跳转各个地方

/**
 * 1专场页，3商品详情，4搜索结果页，5我的卡卷，6快速补货，7分享页，8H5页面
 * 9新人专享，10工厂直供，11一手币，12好卖反馈，13联系客服，14一手帮助，
 * 15提点意见，16一手账单，17订单追踪，18直播间，19H5筛选结果页，23分类页，
 * 24供应商档口，25自助售后商品列表 29今日特卖
 * @param params
 */
export const goToOperating = (params, fromId = "0") => {
  console.log("params", params);
  switch (Number(params.link_type)) {
    case 1: // 专场
      goToApp({
        type: 1,
        id: params.special_id || params.extra_param.link_value,
        fromId,
      });
      break;
    case 3: // 商详
      goToApp({
        type: 0,
        id: params.goods_id || params.extra_param.link_value,
        fromId,
      });
      break;
    case 4: // 搜索结果
      goToApp({
        type: 3,
        id: params.special_id || params.extra_param.link_value,
        keyword: params.keyword,
      });
      break;
    case 8: // h5
      console.log("params", params);
      goToApp({ type: 18, obj: { url: params.url } });
      break;
    case 18: // 直播列表
      goToApp({ type: 7 });
      break;
    case 47: // h5策略中心
      goToApp({ type: 18, obj: { url: params.url } });
      break;
    case 23: // 分类页
      goToApp({ type: 4, id: params.cate_p_id, keyword: params.cate_name });
      break;
    case 24: // 档口
      goToApp({
        type: 2,
        id: params.supplier_id,
        keyword: params.keyword,
        fromId,
      });
      break;
    case 26: // 直播间
      goToApp({ type: 5, obj: params });
      break;
    case 29: // 今日特卖
      goToApp({ type: 22 });
      break;
    case 63: // 达人列表
      goToApp({ type: 63 });
      break;
    // case 30: // 今日特卖秒杀
    //     goToApp({type: 23})
    //     break
  }
};

// 设置app顶部颜色
export const setAppTopColor = (params) => {
  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    if (window.__wxjs_environment !== "miniprogram") {
      // 判断在app才调起
      console.log(
        "设置app顶部颜色",
        params.backColor,
        params.titleColor,
        params.backItemColor
      );
      params = JSON.stringify(params);
      androidOrIos();
      if (isiOS) {
        // try里是旧ios方法 找不到旧方法调catch里的新方法
        try {
          resetNativeColor(params);
        } catch (e) {
          window.webkit.messageHandlers.resetNativeColor.postMessage(params);
        }
      } else if (isAndroid) {
        NativeInvitation.modifyTitleBarStyle(params);
      }
    }
  } else {
    console.log("我在pc浏览器上打开的");
  }
};

export const openWx = () => {
  console.log("拉起微信应用");
  if (isAndroid) {
    NativeInvitation.openWx();
  }
  if (isiOS) {
    console.log("version", version);
    if (version < "4.1.0") {
      console.log("旧方法");
      location.href = "weixin://";
    } else {
      console.log("新方法");
      window.webkit.messageHandlers.openWechat.postMessage(null);
    }
  }
};

/**
 * @param name 要复制的文本
 */
export const copyText = (name) => {
  const params = JSON.stringify({ name });
  if (isAndroid) {
    NativeInvitation.copyFollowYsName(params);
  }
  if (isiOS) {
    try {
      saveWechat(params);
    } catch (e) {
      window.webkit.messageHandlers.saveWechat.postMessage(params);
    }
  }
};

/**
 * @param pic_url 保存图片的链接
 */
export const saveImages = (pic_url) => {
  const params = JSON.stringify({ pic_url });
  if (isAndroid) {
    NativeInvitation.saveImage(params);
  }
  if (isiOS) {
    // try里是旧ios方法 找不到旧方法调catch里的新方法
    try {
      saveImage(params);
    } catch (e) {
      window.webkit.messageHandlers.saveImage.postMessage(params);
    }
  }
};

/**
 * @param shipping_num 查看快递信息
 */
export const lookPackageDetail = (shipping_num) => {
  const params = JSON.stringify({ shipping_num });
  console.log("参数", params);
  if (isAndroid) {
    NativeInvitation.lookPackageDetail(params);
  }
  if (isiOS) {
    // try里是旧ios方法 找不到旧方法调catch里的新方法
    try {
      saveImage(params);
    } catch (e) {
      window.webkit.messageHandlers.lookPackageDetail.postMessage(params);
    }
  }
};

/**
 * @param shipping_num 跳转包裹详情
 */
export const lookPackageDetailFn = (shipping_num) => {
  const params = JSON.stringify({ shipping_num });
  console.log("参数", params);
  if (isAndroid) {
    NativeInvitation.lookPackageDetail(params);
  }
  if (isiOS) {
    try {
      lookPackageDetail(params);
    } catch (e) {
      window.webkit.messageHandlers.lookPackageDetail.postMessage(params);
    }
  }
};

/**
 * @param os_sn跳转到填写快递单号
 */
export const fillExpressNumberFn = (os_sn) => {
  const params = JSON.stringify({ os_sn });
  console.log("参数", params);
  if (isAndroid) {
    NativeInvitation.fillExpressNumber(params);
  }
  if (isiOS) {
    try {
      fillExpressNumber(params);
    } catch (e) {
      window.webkit.messageHandlers.fillExpressNumber.postMessage(params);
    }
  }
};

/**
 *  关闭webview
 */
export const closeWebViewFn = () => {
  if (isAndroid) {
    NativeInvitation.closeWebView();
  }
  if (isiOS) {
    try {
      closeWebView();
    } catch (e) {
      window.webkit.messageHandlers.closeWebView.postMessage(null);
    }
  }
};

/**
 * @myParams h5调起分享 新
 * "{“wechatType”:"1",“webpageUrl”:"url",“path”:"path",
 * “title”:"title",“description”:"description",“thumbImg”:"url",}"
 */
export const shareWechatFn = (myParams) => {
  const params = JSON.stringify(myParams);
  console.log("参数", params);
  if (window.__wxjs_environment === "miniprogram") {
    wx.miniProgram.postMessage({ data: params });
    // 调起小程序
    return;
  }
  if (isAndroid) {
    NativeInvitation.shareWechat(params);
  }
  if (isiOS) {
    try {
      shareWechat(params);
    } catch (e) {
      window.webkit.messageHandlers.shareWechat.postMessage(params);
    }
  }
};

/**
 *  H5调分享（旧的）无需参数
 */
export const invitationFn = () => {
  if (isAndroid) {
    NativeInvitation.invitation();
  }
  if (isiOS) {
    try {
      invitation();
    } catch (e) {
      window.webkit.messageHandlers.invitation.postMessage(null);
    }
  }
};

/**
 * @os_sn 售后工单
 */
export const afterSaleDetailFn = (os_sn) => {
  const params = JSON.stringify({ os_sn });
  if (isAndroid) {
    NativeInvitation.editAfterSaleSheetDetail(params);
  }
  if (isiOS) {
    try {
      afterSaleDetail(params);
    } catch (e) {
      window.webkit.messageHandlers.afterSaleDetail.postMessage(params);
    }
  }
};

// 手机浏览器或微信内拉起app
export const openApp = function (openUrl, callback) {
  location.href = openUrl;

  // 检查app是否打开
  function checkOpen(cb) {
    var _clickTime = +new Date();

    function check(elsTime) {
      if (elsTime > 3000 || document.hidden || document.webkitHidden) {
        cb(1);
      } else {
        cb(0);
      }
    }

    // 启动间隔20ms运行的定时器，并检测累计消耗时间是否超过3000ms，超过则结束
    var _count = 0,
      intHandle;
    intHandle = setInterval(function () {
      _count++;
      var elsTime = +new Date() - _clickTime;
      if (_count >= 100 || elsTime > 3000) {
        clearInterval(intHandle);
        check(elsTime);
      }
    }, 20);
  }

  // 在iframe 中打开APP
  var ifr = document.createElement("iframe");
  ifr.src = openUrl;
  ifr.style.display = "none";

  if (callback) {
    checkOpen(function (opened) {
      callback && callback(opened);
    });
  }

  document.body.appendChild(ifr);
  setTimeout(function () {
    document.body.removeChild(ifr);
  }, 2500);
};

// 用于发信息，用户在手机浏览器打开链接
export const openAppInNavi = function (params) {
  const url = "yishou://fmkj/openyishou?extra=" + params;
  openApp(url, (opened) => {
    if (opened === 0) {
      // 没有安装，跳转下载
      // location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.yishouapp.fumi'
      location.href =
        "https://static.yishouapp.com/app/h5/production/app-download/index.html#/";
    }
  });
};

/**
 *  调用手机相机
 */
export const takePhonePhoto = () => {
  if (isAndroid) {
    NativeInvitation.takePhoto();
  }
  if (isiOS) {
    window.webkit.messageHandlers.takePhoto.postMessage(null);
  }
};

/**
 *  调用相册选择
 */
export const openPhoneAlbume = (params) => {
  params = JSON.stringify(params);
  if (isAndroid) {
    NativeInvitation.openAlbume(params);
  }
  if (isiOS) {
    window.webkit.messageHandlers.openAlbume.postMessage(params);
  }
};
